export default "__VITE_ASSET__BEsRwuPV__"